<template>
  <div>
    <div v-if="getToken">{{ this.$router.push("/balance") }}</div>
    <div v-else>
      <div class="container-center animated fadeIn" v-if="result == 1">
        <div class="text-center">
          <i class="fad fa-check-circle fa-5x text-success"></i>
          <h3>Account activated</h3>
        </div>
        <div class="panel panel-filled">
          <div class="panel-body">
            <p class="m-t-md text-center">
              Congratulations! Your 365stream account has been activated. Please
              log in to start trading.
            </p>
            <p class="m-t-md">
              <router-link to="/signin"
                ><button class="btn btn-accent btn-block text-accent">
                  Log In
                </button></router-link
              >
            </p>
          </div>
        </div>
      </div>

      <div class="container-center animated fadeIn" v-else>
        <div class="text-center">
          <i class="fad fa-times-circle fa-5x text-danger"></i>
          <h3>Account Activation Failed</h3>
        </div>
        <div class="panel panel-filled">
          <div class="panel-body">
            <p class="m-t-md text-center">
              Activation link expired. Please register again.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import nativeToast from "native-toast";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      result: this.$route.params.result
    };
  },
  computed: mapGetters(["getToken"])
};
</script>
